import { Pipe, type PipeTransform } from '@angular/core';
import { type ResultFilterModel } from './result-filter.model';

@Pipe({
    name: 'isActive',
    pure: false, // eslint-disable-line @angular-eslint/no-pipe-impure
})
export class IsActivePipe implements PipeTransform {
    public transform(filter: ResultFilterModel[]): ResultFilterModel[] {
        return filter.filter(item => item.isActive);
    }
}
